// Provider 使用者權限模組
//
// IMPORTANT: module ids MUST match the backend ProviderUserPermissionModule enum,
// which is scope-prefixed (`provider_*`). Sending a legacy un-prefixed id such as
// "user_management" makes PUT /api/providers/:id/users/:id/permissions fail with
// 400 INVALID_PERMISSION_MODULE (previously an opaque 500).
export const PROVIDER_USER_PERMISSION_MODULES = [
  { id: 'provider_user_management', name: '使用者管理' },
  { id: 'provider_clinic_management', name: '診所管理' },
  { id: 'provider_supplier_management', name: '供應商管理' },
  { id: 'provider_provider_settings', name: 'Provider 設定' },
] as const

export type ProviderUserPermissionModuleId =
  (typeof PROVIDER_USER_PERMISSION_MODULES)[number]['id']

export const PROVIDER_USER_PERMISSION_MODULE_IDS: ProviderUserPermissionModuleId[] =
  PROVIDER_USER_PERMISSION_MODULES.map((m) => m.id)

// Build the API payload from the dialog's selected-actions map.
export function buildProviderPermissionsPayload(
  selectedActions: Record<string, string[]>,
): { module: string; allowed_action: string[] }[] {
  return Object.entries(selectedActions).map(([module, allowed_action]) => ({
    module,
    allowed_action,
  }))
}
